var lastTime = new Date().getTime();
var currentTime = new Date().getTime();
var timeOut = 60 * 60 * 1000; //设置超时时间： 30分
//var timeOut = 30; //设置超时时间： 30分
// var timeOut = 10000;
window.onload = function() {
    window.document.onmousedown = function() {
        localStorage.setItem("lastTime", new Date().getTime());
    }
};

function checkTimeout() {
    currentTime = new Date().getTime(); //更新当前时间
    lastTime = localStorage.getItem("lastTime");
    if (currentTime - lastTime > timeOut) { //判断是否超时
        // console.log("超时");
        var url = window.location.href;
        var newUrl = url.match(/(\S*)#/)[1];
        window.open(newUrl + '#/login', '_self');
        localStorage.clear();
    }
}

/* 定时器 间隔30秒检测是否长时间未操作页面 */
window.setInterval(checkTimeout, 60000);